import React from 'react'

class RenderInputV2 extends React.Component {
	render() {
		const { dontShowError, input, label, formClass, placeholder, type, PassReqMobile, isValidatingEmail, meta: { touched, error }, disabled, name, passwordShown, onPasswordReveal } = this.props

		return(
			<div className={`form-group ${formClass} ${touched && error && 'has-error'} ${isValidatingEmail && 'has-warning'}`}>
		    <label dangerouslySetInnerHTML={{__html: label}} />
		    {PassReqMobile}
		    <div style={{position: 'relative'}}>
		      <input
		      	{...input}
		      	placeholder={placeholder}
		      	type={type}
		      	className={`form-control ${touched && error && 'error-form'}`}
				disabled={disabled}
				ref={name}
				autoComplete={type=='password'?'off':''} />
			{onPasswordReveal && (
				<i onClick={onPasswordReveal} className={`fa ${passwordShown ? "fa-eye" : "fa-eye-slash"}`}></i>
			)}
		    </div>
			{dontShowError?
			''
			:
			touched && error && <div className="help-block"><div dangerouslySetInnerHTML={{__html: error}}></div></div>
			}
		      {isValidatingEmail && <div className="help-block">Checking your email...</div>}
		  </div>
		)
	}
}


export default RenderInputV2
